import { render, staticRenderFns } from "./TimeslotSelector.vue?vue&type=template&id=2a6deef4"
import script from "./TimeslotSelector.vue?vue&type=script&lang=js"
export * from "./TimeslotSelector.vue?vue&type=script&lang=js"
import style0 from "./TimeslotSelector.vue?vue&type=style&index=0&id=2a6deef4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports